import { Box } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { EmployeeForSelectFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import TooltipIcon from 'modules/shift_management/components/ShiftManagement//TooltipIcon'
import AddEmployeesNoticeBox from 'modules/shift_management/components/ShiftManagement/AddEmployeesNoticeBox'
import EmployeesSelector from 'modules/shift_management/components/ShiftManagement/EmployeesSelector'
import { useOnSelectEmployees } from 'modules/shift_management/hooks/useOnSelectEmployees'

interface ExtendedForm extends Form {
  employees?: EmployeeForSelectFragment[] | undefined
}

interface Props {
  form: ExtendedForm
  selectableEmployees: Employee[]
  selectedEmployees: number[]
  setSelectedEmployees: (value: number[]) => void
  contractVersions: ContractVersions
}

const AssigneesSelector = ({
  form,
  selectableEmployees,
  selectedEmployees,
  setSelectedEmployees,
  contractVersions,
}: Props) => {
  const errors = form.get('employee_id')?.errors ?? []
  const error = errors[0] ?? undefined
  const { onSelectEmployee } = useOnSelectEmployees({
    form,
    selectedEmployees,
    setSelectedEmployees,
  })

  return (
    <>
      <Box
        className={error && 'error-anchor'}
        flexDirection="row"
        gap="s16"
        justifyContent="center"
        alignItems="center"
      >
        <TooltipIcon.Medium
          icon="person"
          label={i18n.t('shift_management.actions_sidepanel.tooltip.assignee')}
          color="grey700"
        />
        {/* Send error once we migrate to the new EmployeeSelector using GraphQL */}
        <EmployeesSelector
          field={form.get('employee_id')}
          hideLabel
          selectableEmployees={selectableEmployees}
          onSelectEmployee={onSelectEmployee}
          selectedEmployeeIds={selectedEmployees}
          width="s360"
          contractVersions={contractVersions}
        />
      </Box>
      <AddEmployeesNoticeBox newVersion />
    </>
  )
}

export default observer(AssigneesSelector)
